import classes from "./iconSecondary.module.scss";
import SecondaryButton, { SecondaryButtonProps } from "./SecondaryButton";
import React from "react";

type IconSecondaryButtonProps = {
  icon?: React.ReactElement;
} & SecondaryButtonProps

export const IconSecondaryButton = (props: IconSecondaryButtonProps) => {
  const { icon, ...secondaryButtonProps } = props;

  secondaryButtonProps.className = classes.iconButton;

  return (
    <SecondaryButton {...secondaryButtonProps}>
      { icon }
    </SecondaryButton>
  );
};
